import { render, staticRenderFns } from "./StatItem.vue?vue&type=template&id=ad842450&lang=pug&"
import script from "./StatItem.vue?vue&type=script&lang=js&"
export * from "./StatItem.vue?vue&type=script&lang=js&"
import style0 from "./StatItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports